import { AdviceIntroDesc, AdviceMessageStyle } from "./styled";

import { CHILD_MAX_AGE } from "Components/Features/CheckPrice/Products/LifeProducts/Child/childConstants";
import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { TextLanguage } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import { CoverageWarningTexts } from "../../../ProductPriceAka/AkaAdviceCards/CloseToMaxAgeWarning";
import { CHILD_END_AGE } from "../../AdviceCards/adviceCardConstants";
import { useAdviceDetailsFormValues } from "../../hooks/stateSelectors";
import {
  hasChildCloseToMaxAge,
  isChildInsuranceRecommended,
} from "../../utils";

interface Props {
  adviceTexts: any;
  lang: TextLanguage;
  isCollectiveAdvice: boolean;
}

export const ChildAdviceIntroMessage = ({
  adviceTexts,
  lang,
  isCollectiveAdvice,
}: Props): React.ReactElement | null => {
  const toggleChildAdvice = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1335_ADVICE_PRICE_STEP_CHILD_ADVICE,
  );
  const detailsFormValues = useAdviceDetailsFormValues();

  if (
    !toggleChildAdvice ||
    (isDefined(detailsFormValues) &&
      !isChildInsuranceRecommended(detailsFormValues))
  ) {
    return null;
  }

  const warningTexts: CoverageWarningTexts =
    adviceTexts.adviceCards.child.warnings.CHILD;
  return (
    <AdviceMessageStyle>
      <Description
        fw={600}
        size="16px"
        className="AdviceMessageTitle"
        style={{ marginBottom: 0 }}
      >
        {adviceTexts.adviceIntroMessages.insuranceTypes.child[lang]}
      </Description>
      <AdviceIntroDesc fw={400} size="16px" className="AdviceMessageText">
        {replacePlaceholder(
          adviceTexts.adviceIntroMessages.childMessageNew[lang],
          { maxAge: String(CHILD_MAX_AGE) },
        )}
      </AdviceIntroDesc>
      {isDefined(detailsFormValues) &&
        hasChildCloseToMaxAge(detailsFormValues) && (
          <AdviceIntroDesc fw={400} size="16px" className="AdviceMessageWarn">
            {replacePlaceholder(
              isCollectiveAdvice
                ? warningTexts.closeToMaxAge[lang]
                : warningTexts.closeToMaxAgeShort[lang],
              { maxAge: String(CHILD_MAX_AGE), endAge: String(CHILD_END_AGE) },
            )}
          </AdviceIntroDesc>
        )}
    </AdviceMessageStyle>
  );
};
